import React, {Component} from 'react';
import classes from './Search.css';
import Spinner from '../../UI/Spinner/Spinner';
import SearchWindow from '../Search/SearchWindow/SearchWindow';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { BASE_LINE_AGENT_NOT_ALLOWED_MESSAGE, BASIC_SEARCH_TYPE, HSID_BASE, HSID_MEMBER, HSID_PARTIAL_REGISTRATION, ID_TYPES_REVERSED, LS_BASIC_SEARCH_KEY, SESSION_BASELINEAGENT } from '../../shared/Constants';


export class Search extends Component {

    state = {
        searchResult: null,
        localStorageSearchRequest: localStorage.getItem(LS_BASIC_SEARCH_KEY) !== null ? JSON.parse(atob(localStorage.getItem(LS_BASIC_SEARCH_KEY))) : null,
    }

    componentDidMount() {
        // console.log("[Search] componentDidMount");
        this.props.resetSearchResults();
        this.props.setError(null);
        this.restorePersistedSearch();
        window.scrollTo(0, 0);
    }

    restorePersistedSearch = () => {
        this.props.persistedSearchRequest && this.props.doSearch(this.props.persistedSearchRequest, this.props.userType);
    }

    /*
        Only the in-memory request prefills the form on mount, so a page reload starts
        from a clean form. The local storage copy is reserved for back navigation.
    */
    getSearchedKey = () => {
        return this.props.persistedSearchRequest ? this.props.persistedSearchRequest.quickSearchKeyword : "";
    }

    getBackNavigationSearchedKey = () => {
        const request = this.state.localStorageSearchRequest || this.props.persistedSearchRequest;
        return request ? request.quickSearchKeyword : "";
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.loading && !this.props.loading) {
            this.persistSearchRequest();
        }

        // If the length of the result is 1 then we redirect this then we auto select the first item.
        if (this.props.searchResult && this.props.searchResult.length === 1 && !this.props.loading && prevProps.loading) {
            this.memberSelectionHandler(this.props.searchResult[0])
        } 
    }

    /*
        A single result navigates straight to the member page, so only a request that
        yields a result list is worth replaying when the agent comes back to this tab.
    */
    persistSearchRequest = () => {
        const hasResultList = this.props.searchResult && this.props.searchResult.length > 1;
        if (hasResultList && this.props.searchCriteria) {
            this.props.setPersistedSearchRequest(BASIC_SEARCH_TYPE, this.props.searchCriteria);
        } else {
            this.clearPersistedSearch();
        }
    }

    clearPersistedSearch = () => {
        this.props.clearPersistedSearchRequest(BASIC_SEARCH_TYPE);
    }

    setSearchResults =() => {
        this.state.localStorageSearchRequest && this.props.doSearch(this.state.localStorageSearchRequest, this.props.userType)
    }

    searchHandler = (data) => {
        // console.log("[Search] SearchHandler - request data - ", data);
        this.props.doSearch({
            searchType: BASIC_SEARCH_TYPE,
            quickSearchKeyword: data.quickSearchKeyword
        },
        this.props.userType)
    }

    memberSelectionHandler = (data, index) => {
        //console.log("[Search] memberSelectionHandler", data);
        // data.idType = ID_TYPES_REVERSED[data.idType]
        this.props.resetSearchResults();
        const idType = ID_TYPES_REVERSED[data.idType]?ID_TYPES_REVERSED[data.idType]:data.idType;
        if (idType !== HSID_BASE && this.props.userType === SESSION_BASELINEAGENT) {
            this.props.setError({message: BASE_LINE_AGENT_NOT_ALLOWED_MESSAGE});
        } else {
            this.props.history.push({
                pathname: `/member/${btoa(data.uuid?data.uuid:data.id)}/${idType}`,
                state: {idType: idType}
            });
        }
        
    }

    errorHandler = (errObj) => {
        this.props.setError(errObj);
        // this.setState({error: errObj});
    }

    resetQuickSearch = () => {
        this.props.resetSearchResults();
        this.props.setError(null);
    }

    render () {

        // console.log("[Search] render - props search result", this.props.displayMessage);

        let showWindow = null;
        showWindow = <SearchWindow
            quickSearch
            searchResult = {this.props.searchResult}
            searched = {this.searchHandler}
            error={this.props.error}
            errorHandler={this.errorHandler}
            selected={this.memberSelectionHandler}
            displayMessage={this.props.displayMessage}
            searchedKey={ this.getSearchedKey() }
            backNavigationSearchedKey={ this.getBackNavigationSearchedKey() }
            resetSearch={this.resetQuickSearch}
            clearPersistedSearch={this.clearPersistedSearch}
            setSearchResults={this.setSearchResults}
            searchDataLimitPerPage={25}
        />

        const showSpinner = this.props.loading? <Spinner/>: null;

        return(
            <div className={classes.Search}>
                {showWindow}
                {showSpinner}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        searchResult: state.search.searchResults,
        // selectedMember: state.member.selectedMember,
        loading: state.search.loading,
        error: state.search.error,
        displayMessage: state.search.displayMessage,
        searchCriteria: state.search.searchCriteria,
        persistedSearchRequest: actions.getPersistedSearchRequest(state, BASIC_SEARCH_TYPE),
        userType: state.usr.user.userType
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        doSearch: (searchCriteria, userType) => dispatch(actions.doSearch(searchCriteria, userType)),
        resetSearchResults: () => dispatch(actions.resetSearchResults()),
        setError: (error) => dispatch(actions.setError(error)),
        setPersistedSearchRequest: (searchType, request) => dispatch(actions.setPersistedSearchRequest(searchType, request)),
        clearPersistedSearchRequest: (searchType) => dispatch(actions.clearPersistedSearchRequest(searchType)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);